import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "../components/Logo";
import { inputCls } from "../components/request/Field";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain grid-lines relative grid min-h-screen place-items-center px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="relative w-full max-w-md border border-white/10 bg-slab/80 p-8 backdrop-blur-xl md:p-10">
        <Logo />
        <p className="mt-10 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-amber-400"><Lock className="h-3.5 w-3.5" /> Staff only</p>
        <h1 className="mt-3 font-display text-4xl font-black uppercase tracking-tight">Bench login</h1>
        <div className="mt-8 space-y-4">
          <input data-testid="admin-email-input" type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" autoComplete="username" />
          <input data-testid="admin-password-input" type="password" required className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" autoComplete="current-password" />
        </div>
        {err && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">{err}</p>}
        <button data-testid="admin-login-submit-btn" disabled={busy} className="mt-8 inline-flex w-full items-center justify-center gap-2 bg-ember px-6 py-4 font-semibold text-ink hover:bg-amber-400 disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
